export default {
  type_1: [{ paymentCode: '', paymentName: '', amount: 0, processedAt: new Date().toISOString(), note: '' }],
  type_2: [
    { paymentCode: '', paymentName: '', amount: 0, processedAt: new Date().toISOString(), note: '' },
    { paymentCode: '', paymentName: '', amount: 0, processedAt: new Date().toISOString(), note: '' }
  ],
  type_3: [
    { paymentCode: '', paymentName: '', amount: 0, processedAt: new Date().toISOString(), note: '' },
    { paymentCode: '', paymentName: '', amount: 0, processedAt: new Date().toISOString(), note: '' },
    { paymentCode: '', paymentName: '', amount: 0, processedAt: new Date().toISOString(), note: '' }
  ]
}
